import { Tooltip } from "@mui/material";
import { Icon, Tag } from "pepsico-ds";

export const TABLE_CONFIG = {
  ROWS_PER_PAGE: 10,
  NO_DATA_LABEL: "No stores available",
};

export const STORE_HEADER_DATA = [
  {
    columnKey: "storeId",
    header: "Store ID",
  },
  {
    columnKey: "name",
    header: "Store Name",
  },
  {
    columnKey: "retailer",
    header: "Retailer",
  },
  {
    columnKey: "country",
    header: "Country",
  },
  {
    columnKey: "state",
    header: "State",
  },
  {
    columnKey: "city",
    header: "City",
  },
  {
    columnKey: "postcode",
    header: "Postal Code",
  },
  {
    columnKey: "category",
    header: "Store Group",
  },
  {
    columnKey: "actions",
    header: "Actions",
    className: "text-center",
  },
];

export const STORE_GROUP_HEADER_DATA = [
  {
    columnKey: "name",
    header: "Group Name",
  },
  {
    columnKey: "storeCount",
    header: "Store Count",
  },
  {
    columnKey: "zipCodes",
    header: "Zip Codes",
  },
  {
    columnKey: "actions",
    header: "Actions",
    className: "text-center",
  },
];

export const renderZipCodes = (zipCodes = []) => {
  if (!zipCodes.length) return "-";
  const display = zipCodes.slice(0, 2).join(", ");
  if (zipCodes.length <= 2) return <span>{display}</span>;
  return (
    <Tooltip title={zipCodes.join(", ")} arrow placement="top">
      <span style={{ cursor: "pointer" }}>{display}, ...</span>
    </Tooltip>
  );
};

export const STYLES = {
  actions: {
    display: "flex",
    gap: "12px",
    alignItems: "center",
    justifyContent: "center",
  },
  editIcon: {
    cursor: "pointer",
    color: "#007bff",
    fontSize: "16px",
  },
  deleteIcon: {
    cursor: "pointer",
    color: "#dc3545",
    fontSize: "16px",
  },
  disabledIcon: {
    cursor: "not-allowed",
    color: "#6c757d",
    fontSize: "16px",
    opacity: 0.5,
  },
  viewIcon: {
    cursor: "pointer",
    color: "#17a2b8",
    fontSize: "16px",
  },
  loadingContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "200px",
  },
};

export const MESSAGES = {
  LOADING: "Loading stores...",
  EDIT_TOOLTIP: "Edit store",
  DELETE_TOOLTIP: "Delete store",
  DELETE_DISABLED_TOOLTIP: "Cannot delete - already deleted",
  VIEW_TOOLTIP: "View stores in group",
};

export const TAG_COLORS = {
  ACTIVE: "Green-500",
  DELETED: "Red-500",
  GROUP: "Blue-500",
};

export const VIEW_OPTIONS = [
  { id: "stores", displayText: "Stores" },
  { id: "store-groups", displayText: "Store Groups" },
];

export const createStatusTag = (deleted) => (
  <Tag
    text={deleted ? "Deleted" : "Active"}
    color={deleted ? TAG_COLORS.DELETED : TAG_COLORS.ACTIVE}
    isCopyable={false}
  />
);

export const createStoreActionButtons = (store, onEdit, onDelete) => (
  <div style={STYLES.actions}>
    <Icon
      icon="edit"
      onClick={() => onEdit(store)}
      style={STYLES.editIcon}
      title={MESSAGES.EDIT_TOOLTIP}
    />
    <Icon
      icon="delete"
      onClick={store.deleted ? undefined : () => onDelete(store.id, store.name)}
      style={store.deleted ? STYLES.disabledIcon : STYLES.deleteIcon}
      title={
        store.deleted ? MESSAGES.DELETE_DISABLED_TOOLTIP : MESSAGES.DELETE_TOOLTIP
      }
    />
  </div>
);

export const createGroupActionButtons = (
  groupName,
  onViewGroup,
  onEditGroup,
  onDeleteGroup
) => (
  <div style={STYLES.actions}>
    <Icon
      icon="visibility"
      onClick={() => onViewGroup(groupName)}
      style={STYLES.viewIcon}
      title={MESSAGES.VIEW_TOOLTIP}
    />
    <Icon
      icon="edit"
      onClick={() => onEditGroup(groupName)}
      style={STYLES.editIcon}
      title="Rename group"
    />
    <Icon
      icon="delete"
      onClick={() => onDeleteGroup(groupName)}
      style={STYLES.deleteIcon}
      title="Delete group"
    />
  </div>
);
